import EventEmitter from 'eventemitter3';

/**
 * Lets a surface outside the chat (e.g. the script composer) ask an
 * already-mounted in-creator chat to consume a freshly staged hand-off message
 * — the chat's own mount-time consume has already run by then.
 */
export enum CHAT_HANDOFF_EVENTS {
    CONSUME_STAGED_MESSAGE = 'CONSUME_STAGED_MESSAGE',
}

const ChatHandoffEventEmitter = new EventEmitter();
export default ChatHandoffEventEmitter;

export const requestChatHandoffConsume = (): void => {
    ChatHandoffEventEmitter.emit(CHAT_HANDOFF_EVENTS.CONSUME_STAGED_MESSAGE);
};
